import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/AminiiErrorPage.css";

function AminiiErrorPage({ message, showHomeButton = true }) {
  const navigate = useNavigate();

  return (
    <div className="amin-error-page">
      <div className="amin-error-brand">
        <p className="amin-error-brand-n">A M I N I I</p>
        <p className="amin-error-brand-s">C L O T H I N G</p>
      </div>
      <div className="amin-error-divider" />
      <div className="amin-error-content">
        <p className="amin-error-title">Oops! Something went wrong.</p>
        <p className="amin-error-message">
          {message || "We ran into an unexpected issue. Please try again."}
        </p>
        <p className="amin-error-contact">
          Need help?{" "}
          <a href="mailto:aminiiclothings@gmail.com" className="amin-error-email">
            aminiiclothings@gmail.com
          </a>
        </p>
        {showHomeButton && (
          <button
            className="amin-explore-btn"
            onClick={() => navigate("/")}
            type="button"
          >
            Back to Home
          </button>
        )}
      </div>
    </div>
  );
}

export default AminiiErrorPage;
